import { render, staticRenderFns } from "./PersonDetails.vue?vue&type=template&id=04c67a5c&scoped=true&"
import script from "./PersonDetails.vue?vue&type=script&lang=js&"
export * from "./PersonDetails.vue?vue&type=script&lang=js&"
import style0 from "../../assets/css/personnel.css?vue&type=style&index=0&id=04c67a5c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04c67a5c",
  null
  
)

export default component.exports